var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-xxl-6 col-xl-6 mb-3"
  }, [_c('h5', {
    staticClass: "title-section"
  }, [_vm._v("Top 5 Termination/Withdrawn Reasons")]), _c('div', {
    staticClass: "overallInfo-blockWrapper noHeight dashboard-card p-3 pb-2"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', [!_vm.sortedList.length ? [_vm._m(1)] : _vm._l(_vm.sortedList, function (item) {
    return _c('tr', {
      key: item.act
    }, [_c('td', [_vm._v(_vm._s(_vm.getReasonName(item.act)))]), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.total))]), _c('td', [_vm._v(_vm._s(item.percentage) + "%")])]);
  })], 2)])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Reasons")]), _c('th', [_vm._v("Total Members")]), _c('th', [_vm._v("(in %)")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No records found")])]);
}]

export { render, staticRenderFns }